import { combineActions, handleActions } from 'redux-actions'
import { REHYDRATE } from 'redux-persist'
import { fromJS, Map, List } from 'immutable'
import { LOCATION_CHANGE } from 'connected-react-router'

import { activityActions, getIdentityProgress, subscribeToProTrack, postInvite } from 'store/entities/identity/actions'
import LocalSettings from './LocalSettings'
import {
  setTopNotificationBlockShown,
  onSetSubscriptionState,
  onNotificationsBlocked,
  setNotificationsPending,
  initOneSignalSuccess,
  setConfirmationModal,
  closeShowLoginInformationModal,
  setQueries,
  setConfirmationModalForStopProTrack,
  setConfirmationModalForDifferentProTrack,
  loadLanguages,
  fetchCountriesCodes,
  setConfirmationModalForCommitPreviousActivity,
  setShouldAutoPlayVideo,
} from './actions'

import { ILocalSettingsRecord } from './interface'

const handleRehydrate = (state: ILocalSettingsRecord, { payload }: any) => {
  return payload && payload.localSettings && payload.localSettings.set
    ? payload.localSettings
        .set('isOneSignalInitialized', false)
        .set('isPending', false)
        .set('loadedLanguages', Map())
        .set('isShowConfirmationModalForCommitPreviousActivity', false)
        .set('isShowConfirmationModalForSwitchProTrack', false)
        .set('isShowConfirmationModalForStopProTrack', false)
        .set('isShowConfirmationModalForDifferentProTrack', false)
        // TODO: perhapse should not be here @Razzwan
        .set('isNotificationsBlocked', false)
        .set('breadcrumbs', List())
        .set('isShouldAutoPlayVideo', false)
    : state
}

const handleSetTopNotification = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('isTopNotificationBlockShown', payload)
}

const setTopNotificationAsShown = (state: ILocalSettingsRecord) => state.set('isTopNotificationBlockShown', true)

const handleSetSubscriptionState = (state: ILocalSettingsRecord, { payload: { isPushEnabled, isOptedOut } }: any) => {
  return state
    .set('isPending', false)
    .set('isPushEnabled', isPushEnabled)
    .set('isOptedOut', isOptedOut)
    .set('isNotificationsBlocked', isPushEnabled || isOptedOut ? false : state.get('isNotificationsBlocked'))
}

const handleNotificationsBlocked = (state: ILocalSettingsRecord) => {
  return state.set('isNotificationsBlocked', true)
}

const handleNotificationsPending = (state: ILocalSettingsRecord, { payload = true }) => {
  return state.set('isPending', payload)
}

const handleInitOneSignalSuccess = (state: ILocalSettingsRecord) => {
  return state.set('isOneSignalInitialized', true)
}

const handleSetConfirmationModal = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('isShowConfirmationModalForSwitchProTrack', payload)
}

const handleSetShowLoginInformationModal = (value: any) => (state: ILocalSettingsRecord) => {
  return state.set('isShowLoginInformationModal', value)
}

const handleSetConfirmationModalForStopProTrack = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('isShowConfirmationModalForStopProTrack', payload)
}

const handleSetConfirmationModalForCommitPreviousActivity = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('isShowConfirmationModalForCommitPreviousActivity', payload)
}

const handleSetConfirmationModalForDifferentProTrack = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('isShowConfirmationModalForDifferentProTrack', payload)
}

const handleSetQueries = (state: ILocalSettingsRecord, { payload }: any) => {
  const queries = state.get('queries').merge(payload)
  return state.set('queries', queries as any)
}

const handleLoadLanguages = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('loadedLanguages', <any>fromJS(payload))
}

const handleFetchCountriesCodesSuccess = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('countriesCodes', <any>fromJS(payload.data))
}

const handleLocationChange = (
  state: ILocalSettingsRecord,
  {
    payload: {
      location: { pathname },
    },
  }: any
) => {
  const bc = state.get('breadcrumbs')
  return state.set('breadcrumbs', bc.push(pathname))
}

const handlesetShouldAutoPlayVideo = (state: ILocalSettingsRecord, { payload }: any) => {
  return state.set('isShouldAutoPlayVideo', payload)
}

export default handleActions(
  {
    [REHYDRATE]: handleRehydrate,
    [setTopNotificationBlockShown as any]: handleSetTopNotification,
    [combineActions(
      getIdentityProgress.success,
      activityActions.commit.success,
      activityActions.did.success,
      activityActions.didnot.success,
      activityActions.complete.success,
      subscribeToProTrack.success
    ) as any]: setTopNotificationAsShown,
    [onSetSubscriptionState as any]: handleSetSubscriptionState,
    [onNotificationsBlocked as any]: handleNotificationsBlocked,
    [setNotificationsPending as any]: handleNotificationsPending,
    [initOneSignalSuccess as any]: handleInitOneSignalSuccess,
    [setConfirmationModal as any]: handleSetConfirmationModal,
    [setConfirmationModalForStopProTrack as any]: handleSetConfirmationModalForStopProTrack,
    [setConfirmationModalForDifferentProTrack as any]: handleSetConfirmationModalForDifferentProTrack,
    [setConfirmationModalForCommitPreviousActivity as any]: handleSetConfirmationModalForCommitPreviousActivity,
    [postInvite.success as any]: handleSetShowLoginInformationModal(true),
    [closeShowLoginInformationModal as any]: handleSetShowLoginInformationModal(false),
    [setQueries as any]: handleSetQueries,
    [loadLanguages as any]: handleLoadLanguages,
    [fetchCountriesCodes.success as any]: handleFetchCountriesCodesSuccess,
    [LOCATION_CHANGE as any]: handleLocationChange,
    [setShouldAutoPlayVideo as any]: handlesetShouldAutoPlayVideo,
  },
  new LocalSettings()
)
